/**
 * @param {Phaser.GameObjects.Sprite} gameObject
 * @param {import("../types/typedef").CameraRegion[]} cameraRegions
 */
function getCameraRegionsForGameObject(gameObject, cameraRegions) {
  return cameraRegions.filter((region) => {
    return (
      gameObject.x >= region.x &&
      gameObject.x <= region.x + region.width &&
      gameObject.y >= region.y &&
      gameObject.y <= region.y + region.height
    );
  });
}

/**
 * @param {import("../types/typedef").CameraRegion[]} cameraRegions
 */
function getUnionBoundsForCameraBounds(cameraRegions) {
  if (cameraRegions.length === 0) {
    return undefined;
  }
  const minX = Math.min(...cameraRegions.map((region) => region.x));
  const maxX = Math.max(...cameraRegions.map((region) => region.x + region.width));
  const minY = Math.min(...cameraRegions.map((region) => region.y));
  const maxY = Math.max(...cameraRegions.map((region) => region.y + region.height));
  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}

/**
 * Updates the main camera bounds in a phaser scene based on the provided
 * game objects position and the available camera regions.
 * @param {Phaser.Scene} scene
 * @param {Phaser.GameObjects.Sprite} gameObject
 * @param {import("../types/typedef").CameraRegion[]} cameraRegions
 */
export function updateMainCameraBounds(scene, gameObject, cameraRegions) {
  const filteredRegions = getCameraRegionsForGameObject(gameObject, cameraRegions);
  if (filteredRegions.length === 0) {
    return false;
  }
  const unionBounds = getUnionBoundsForCameraBounds(filteredRegions);
  if (unionBounds === undefined) {
    return false;
  }
  // Perf: this runs on every grid-step the player takes. setBounds() recomputes the camera's
  // internal clamp + marks it dirty, so only call it when the resolved bounds actually change.
  const camera = scene.cameras.main;
  const current = camera.getBounds();
  if (
    current.x === unionBounds.x &&
    current.y === unionBounds.y &&
    current.width === unionBounds.width &&
    current.height === unionBounds.height
  ) {
    return false;
  }
  camera.setBounds(unionBounds.x, unionBounds.y, unionBounds.width, unionBounds.height);
  // Tell the caller the bounds changed — a camera region can be narrower than the full map, so the
  // cover-fit zoom must be recomputed against the NEW bounds or the viewport is left with a void.
  return true;
}
